import { Box } from '@primer/react';
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { useThongKeSiSo } from '../../hooks/useThongKeSiSo';

// Đăng ký các thành phần cho biểu đồ
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ChartSiSoTheoKhoi = () => {
    const { dataStructed } = useThongKeSiSo();
    const dataSource = useMemo(() => {
        let result: any[] = [];
        dataStructed.forEach((value, key) => {
            value.items.forEach((khoi) => {
                result.push({
                    id: khoi.id,
                    text: khoi.name,
                    si_so: khoi.si_so
                })
            })

        })
        return result;
    }, [dataStructed])

    // Chuẩn bị dữ liệu cho Bar Chart
    const data = {
        labels: dataSource.map(item => item.text), // Nhãn các môn học
        datasets: [
            {
                label: '',
                data: dataSource.map(item => item.si_so), // Điểm tương ứng
                backgroundColor: '#006BFF', // Màu cột
                borderColor: '#006BFF', // Viền cột
                borderWidth: 1,
                barThickness: 20, // Độ dày của thanh Bar (pixel)
                maxBarThickness: 30, // Độ dày tối đa của mỗi Bar
                borderRadius: 4, // Bo tròn góc tha
            },
        ],
    };
    const options: any = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                display: false,
            },
            title: {
                display: true,
                text: '',
            },
            datalabels: {
                color: 'black', // Màu chữ trắng
                anchor: 'end',
                align: 'start',
                offset: -20,
                font: {
                    weight: 'bold',
                    size: 13,
                },
            },
        },
        // scales: {
        //     y: {
        //         min: 0, // Điểm tối thiểu
        //         max: 10, // Điểm tối đa
        //         ticks: {
        //             stepSize: 1, // Khoảng cách giữa các giá trị
        //         },
        //     },
        // },
    };
    return (
        <>
            <Box sx={{ fontSize: 24, fontWeight: 600 }}>Sĩ số theo khối</Box>
            <Box sx={{ fontSize: "1rem", color: "fg.muted" }}>Số học sinh theo từng khối</Box>
            <Bar data={data} options={options} style={{
                width: "100%",
                height: "auto"
            }} />
        </>
    );
};

export default ChartSiSoTheoKhoi;